import { Component, OnInit } from '@angular/core';
import { StatusService } from '../../shared/services/status.service';
import { BusyService } from '../../shared/services/busy.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/primeng';
import { Status } from '../../shared/models/Status';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../shared/services/auth.service';
import { User } from '../../shared/models/User';

@Component({
  selector: 'app-status-sounds',
  templateUrl: './status-sounds.component.html',
  styleUrls: ['./status-sounds.component.scss']
})
export class StatusSoundsComponent implements OnInit {
  busy = false;
  model = {
    sounds: []
  };
  enableEdit = false;
  deleteActionModel: any = {
    deleteConfirmationShow: false,
    statusDescription: '',
    statusId: -1
  };
  user: User;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private busyService: BusyService,
    private statusSounds: StatusService,
    private confirmationService: ConfirmationService
  ) {
    this.user = AuthService.currentUser();

    if (!this.user.isInRole(['sysadmin', 'superuser'])) {
      this.router.navigate(['/orgedit/' + this.user.organizationId]);
    } else {
      if (this.user.isInRole(['superuser'])) {
        this.enableEdit = true;
      }
    }

    this.busyService.initHandler('statusSoundsCmp', busy => {
      this.busy = busy;
    });
  }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.loadData();
    });
  }

  loadData() {
    this.busyService
      .follow('statusSoundsCmp', this.statusSounds.all())
      .subscribe(sounds => {
        this.model.sounds = sounds;
      });
  }

  delete(status) {
    this.confirmationService.confirm({
      message:
        'Are you sure that you want to delete "' +
        status.statusDescription +
        '" ?',
      accept: () => {
        this.busyService
          .follow('statusSoundsCmp', this.statusSounds.delete(status.statusId))
          .subscribe(result => {
            this.loadData();
          });
      }
    });
  }

  edit(status) {
    this.router.navigate(['statedit/' + status.statusId]);
  }

  getToPaginatorLabel(dt) {
    if (dt.rows > dt.totalRecords) {
      return dt.totalRecords;
    } else {
      if (dt.rows + dt.first > dt.totalRecords) {
        return dt.totalRecords;
      } else {
        return dt.first + dt.rows;
      }
    }
  }

  getSoundFileApi(filename) {
    const soundFilepath =
      environment.api.baseUrl +
      environment.api.status.play.replace('{filename}', filename) +
      (filename.toString().indexOf('?') > 0
        ? '&access_token='
        : '?access_token=') +
      encodeURIComponent(this.user.token);
    return soundFilepath;
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/authorized/status-sounds/status-sounds.component.ts